import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources } from './locales';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'br',
    debug: true,

    // Le breton est la langue par défaut : on ne consulte pas la langue du
    // navigateur, seul un choix explicite déjà mémorisé prime.
    detection: {
      order: ['querystring', 'localStorage', 'sessionStorage'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
